import { CONTACT_EMAIL, MYAPP_URL, NEW_PORTAL_URL, SHUTDOWN_DATE } from '../legacyPolicy';
import './MovedCard.scss';

interface MovedCardProps {
  showExcelNote?: boolean;
}

const MovedCard = ({ showExcelNote = false }: MovedCardProps) => (
  <div className='moved-card' data-testid='legacy-move-notice'>
    <img className='moved-card__logo' src='/img/larasoft-landscape.png' alt='Larasoft' />
    <h2 className='moved-card__title'>We have moved</h2>
    <p className='moved-card__text'>
      Everything on Larasoft except the Excel Connector now lives in our new portal. Please sign in there to carry on.
    </p>
    <p className='moved-card__text'>
      The Excel Connector has been upgraded to{' '}
      <a href={MYAPP_URL} target='_blank' rel='noreferrer'>
        <strong>MyApp</strong>
      </a>
      . Reach out to <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a> for your free migration.
    </p>
    <span className='moved-card__date'>This site closes on {SHUTDOWN_DATE}</span>
    <a className='moved-card__button' href={NEW_PORTAL_URL}>
      Go to the new portal
    </a>
    {showExcelNote && (
      <p className='moved-card__note'>The old Excel Connector carries on here for now, so you can keep signing in on this page to use it.</p>
    )}
  </div>
);

export default MovedCard;
